
export enum API_ENVIRONMENT_TYPES {
    development = "development",
    preprod = "preprod",
    production = "production",
}

export enum APP_ENVIRONMENT_TYPES {
    local = "local",
    development = "development",
    preprod = "preprod",
    production = "production",
}

export enum LMS_ENVIRONMENT_TYPES {
    local = "local",
    development = "development",
    preprod = "preprod",
    production = "production",
}

export const API_URLS = {
    [API_ENVIRONMENT_TYPES.development]: {
        "default": "https://preprod.lms.api.tralalere.com/",
    },
    [API_ENVIRONMENT_TYPES.preprod]: {
        "amazon_python": "https://preprod.api-next.citizencode.tralalere.com/",
        "cycle-1-tne-canope": "https://preprod.api.cycle1tnecanope.tralalere.com/",
        "cycle-2-et-3-tne-canope": "https://preprod.api.cycle2et3tnecanope.tralalere.com/",
        "cycle-4-tne-canope": "https://preprod.api.cycle4tnecanope.tralalere.com/",
        "default": "https://preprod.lms.api.tralalere.com/",
        "humanum": "https://preprod.api-next.humanum.tralalere.com/",
        "inclusive": "https://preprod.api.inclusive.tralalere.com/",
        "isc_lycee": "https://preprod.api.lycee.internetsanscrainte.education/",
        "isc_college": "https://preprod.api.college.internetsanscrainte.education/",
        "sapiens": "https://preprod.api-next.sapiens.tralalere.com/",
        "mathia": "https://preprod.lms-mathia.api.tralalere.com/",
        "verdinum": "https://preprod.api.verdinum.jeunes.tralalere.com/",
    },
    [API_ENVIRONMENT_TYPES.production]:{
        "default": "https://preprod.lms.api.tralalere.com/",
        "humanum": "https://api.humanum.tralalere.com/",
        "isc_lycee": "https://api.lycee.internetsanscrainte.education/",
    }
} as const;

export const APP_URLS = {
    [APP_ENVIRONMENT_TYPES.local]: {
        "default": "http://localhost:4300/",
    },
    [APP_ENVIRONMENT_TYPES.development]: {
        "default": "https://preprod.lms.tralalere.com/",
        "humanum":"https://preprod.app-next.humanum.tralalere.com/"
    },
    [APP_ENVIRONMENT_TYPES.preprod]: {
        "default": "https://preprod.lms.tralalere.com/",
        "humanum": "https://preprod.app-next.humanum.tralalere.com/",
    },
    [APP_ENVIRONMENT_TYPES.production]: {
        "default": "https://app.ilove.tralalere.com/",
    }
}

export const LMS_URLS = {
    [LMS_ENVIRONMENT_TYPES.local]: {
        "default": "http://localhost:4200/",
    },
    [LMS_ENVIRONMENT_TYPES.development]: {
        "default": "https://preprod.lms.tralalere.com/",
    },
    [LMS_ENVIRONMENT_TYPES.preprod]: {
        "default": "https://preprod.lms.tralalere.com/",
        "sapiens": "https://preprod.lms-next.sapiens.tralalere.com/",
        "amazon_python": "https://preprod.lms-next.citizencode.tralalere.com/",
        "humanum": "https://preprod.lms-next.humanum.tralalere.com/"
    },
    [LMS_ENVIRONMENT_TYPES.production]: {
        "default": "https://lms.ilove.tralalere.com/",
    }
}

export const APP_EXTERNAL_URLS = {
    [APP_ENVIRONMENT_TYPES.production]: {
        'default': 'https://www.catalogue.education/commande-hors-tne/?ressource=humanum',
        'humanum': 'https://www.catalogue.education/commande-hors-tne/?ressource=humanum'
    },
    [APP_ENVIRONMENT_TYPES.preprod]: {
        'default': 'https://preprod.tnecanope.tralalere.com/commande-hors-tne/?ressource=humanum',
        'humanum': 'https://preprod.tnecanope.tralalere.com/commande-hors-tne/?ressource=humanum'
    },
    [APP_ENVIRONMENT_TYPES.development]: {
        'default': 'https://preprod.tnecanope.tralalere.com/commande-hors-tne/?ressource=humanum',
        'humanum': 'https://preprod.tnecanope.tralalere.com/commande-hors-tne/?ressource=humanum'
    }
}

export const getUrl = (matrix: typeof APP_URLS | typeof API_URLS | typeof APP_EXTERNAL_URLS | typeof LMS_URLS, brand: string, environment: string): string => {
    const defaultEnvironment = 'development';

    const env = matrix[environment] || matrix[defaultEnvironment];

    return env[brand] || env.default;
}